import { combineReducers, Reducer } from 'redux';
import {
  BEGIN_FETCH,
  DownloadAction,
  FETCH_COMPLETED,
  SET_CREDIT_NOTE,
  SET_INVOICE,
} from './types';
import { InvoiceStamp, InvoiceItem, Page } from 'types/type';

export interface CreditNoteState {
  readonly isFetching: boolean;
  readonly creditNotesPage: Page<InvoiceStamp>;
  readonly invoiceInfo: InvoiceItem;
}

const creditNotesPage: Reducer<Page<InvoiceStamp>> = (
  state: Page<InvoiceStamp> = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 0,
  },
  action,
): Page<InvoiceStamp> => {
  switch (action.type) {
    case SET_CREDIT_NOTE:
      return { ...action.creditNotesPage };
    case 'CLEAN':
      return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        number: 0,
        size: 0,
      };
    default:
      return state;
  }
};

const invoiceInfo: Reducer<InvoiceItem> = (
  state: InvoiceItem = {
    id: '',
    loteFactura: { loteId: '', global: false },
    createdAt: '',
    updatedAt: '',
    multiple: false,
    emailEnviado: false,
    periodicity: '',
    periodicityMonth: '',
    periodicityYear: '',
    startPeriod: '',
    endPeriod: '',
    permissionNumber: '',
    stampedDate: '',
    idUserCreate: '',
    status: '',
    grouper: '',
    groups: '',
    invoiceError: '',
    type: '',
    uuidSat: '',
    statusSat: '',
    cancelableSat: '',
    cancellationStatusSat: '',
    total: '',
    totalVolume: '',
  },
  action,
): InvoiceItem => {
  switch (action.type) {
    case SET_INVOICE:
      return { ...action.invoiceInfo };
    default:
      return state;
  }
};

const isFetching: Reducer<boolean> = (
  state = false,
  action: DownloadAction,
): boolean => {
  switch (action.type) {
    case BEGIN_FETCH:
      return true;
    case FETCH_COMPLETED:
      return false;
    default:
      return state;
  }
};

export default combineReducers<CreditNoteState>({
  isFetching,
  creditNotesPage,
  invoiceInfo,
});
